import PropTypes from 'prop-types'
import React from 'react'
import ScriptLoader from '../../ScriptLoader'

const resolveBrightcoveScriptSrc = playerId =>
  `https://players.brightcove.net/${process.env.REACT_APP_BRIGHTCOVE_ACCOUNT_ID}/${playerId}_default/index.min.js`

const BrightcovePlayer = ({ playerId, loaderSize = 'default', children }) =>
  <ScriptLoader className='video-loader' src={ resolveBrightcoveScriptSrc(playerId) } loaderSize={ loaderSize }>
    { children }
  </ScriptLoader>

BrightcovePlayer.propTypes = {
  playerId: PropTypes.string.isRequired,
  loaderSize: PropTypes.oneOf(['default', 'small', 'max']),
  children: PropTypes.node,
}

export default BrightcovePlayer
